module.exports = __webpack_public_path__ + "static/media/amex_color.20ba3f19.png";